import { CommonPage, Content, LoadableContent, PageTitle, ResponsiveGap } from "common/Grid";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { WithPagination } from "common/Pagination";
import { createSearchParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useGetInquiriesMutation } from "store/action/inquiryApi";
import { TableView } from "./TableView";


export const Page = () => {
  const [getInquiriesApi, {isLoading, isError}] = useGetInquiriesMutation();
  const pagedInquiryInfo = useSelector((state) => state?.inquiry);
  const [searchParams, setSearchParams] = useSearchParams();

  const searchFields = useMemo(() =>
  ({
    page: { name: 'p', default: 1, },
    limit: { name: 'ps', default: 10, },
  }), []);

  const getSearchValue = useCallback((name, defaultValue, getter = (value) => value) => {
    const value = searchParams.get(name);
    if (value === null) {
      return defaultValue;
    }
    return getter(value);
  }, [searchParams])

  const page = useRef(getSearchValue(searchFields.page.name, searchFields.page.default, x => parseInt(x) ?? searchFields.page.default));
  const limit = useRef(getSearchValue(searchFields.limit.name, searchFields.limit.default, x => parseInt(x) ?? searchFields.limit.default));

  const searchAsync = useCallback(async () => {
    await getInquiriesApi(
      {
        page: page.current,
        limit: limit.current,
      }
    );
  }, [getInquiriesApi, getSearchValue]);

  const applySearch = useCallback(() => {
    const updatedSearchParams = createSearchParams(searchParams);
    updatedSearchParams.set(searchFields.page.name, `${page.current}`);
    updatedSearchParams.set(searchFields.limit.name, `${limit.current}`);
    setSearchParams(updatedSearchParams);
  }, [searchFields, searchParams, setSearchParams]);

  const onPageHandler = (pageRequest) => {
    page.current = pageRequest + 1;
    applySearch();
  };

  const onPageSizeHandler = (sizeRequest) => {
    limit.current = sizeRequest;
    page.current = 1;
    applySearch();
  };

  useEffect(() => {
    searchAsync();
  }, [searchAsync]);

  useEffect(() => {
    applySearch();
  }, []);

  return (
    <>
    <CommonPage>
      <Content>
        <PageTitle title="Inquiries" />
        <ResponsiveGap left={false} right={false}>
          <LoadableContent isLoading={isLoading}
                          isError={isError}>
            <WithPagination id='pagedData'
              currentPage={pagedInquiryInfo?.data?.data?.currentPage - 1 ?? 0}
              totalPages={pagedInquiryInfo?.data?.data?.totalPages ?? 0}
              totalItems={pagedInquiryInfo?.data?.data?.total ?? 0}
              pageSize={limit.current ?? 0}
              onPageChange={onPageHandler}
              onPageSizeChange={onPageSizeHandler}
              paginationWrapper={x => <ResponsiveGap>{x}</ResponsiveGap>}>
              <TableView list={pagedInquiryInfo?.data?.data?.data} searchAsync={searchAsync} />
            </WithPagination>
          </LoadableContent>
        </ResponsiveGap>
      </Content>
    </CommonPage>
    </>
  )
}
